import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    borderedButton: {
      alignItems: 'center',
      borderRadius: 16,
      borderWidth: 2,
      borderColor: colors.link,
    },
    filledButton: {
      alignItems: 'center',
      backgroundColor: colors.link,
      borderRadius: 16,
    },
    titleStyle: {
      fontSize: 16,
      fontFamily: FONTS.semiboldFont,
      lineHeight: 24,
      marginVertical: 16,
    },
    op07: {
      opacity: 0.7,
    },
  });

export default makeStyles;
